import {apiLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {ICMSResponse} from "../types/ICMSResponse";
import {IPageSectionPayload} from "../types/IPageSectionPayload";

export const cmsPageSections = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getPageSection: builder.query<ICMSResponse, IPageSectionPayload>({
            query: (params) => ({
                url: apiLink.cms.pageSection({})({slug: params.slug}),
                method: "GET"
            })
        })
    })
});

export const {useGetPageSectionQuery} = cmsPageSections;
import {apiLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {ICMSResponse} from "../types/ICMSResponse";
import {IPageSectionPayload} from "../types/IPageSectionPayload";

export const cmsPageSections = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getPageSection: builder.query<ICMSResponse, IPageSectionPayload>({
            query: (params) => ({
                url: apiLink.cms.pageSection({})({slug: params.slug}),
                method: "GET"
            })
        })
    })
});

export const {useGetPageSectionQuery} = cmsPageSections;
